import React, { useState } from "react";
import WeekSelector from "../../../components/WeekSelector";
import { useSiteContext } from "../../../SiteContext";
import PaycorManager from "../../../managers/PaycorManager";
import "./PaycorDownload.css";
import PageWrapper from "../../../components/PageWrapper";
import Colors from '../../../styles/Colors.json';

interface PaycorPrdaLocalProps {
  setError: (error: string | null) => void;
}

const PaycorPrdaLocal: React.FC<PaycorPrdaLocalProps> = ({ setError }) => {
  const { setLoading, year, startDate, endDate, week, payPeriodID, createPopup, translator } = useSiteContext();

  const handleDownloadClick = async () => {
    try {
      createPopup('Download Initiated', `Getting Paycor PRDA Local File for week ${week}, ${year}.`)
      setLoading(true);

      // Call the PRDA Local method to download the .xlsx file directly
      await PaycorManager.downloadPaycorPrdaLocalFile(payPeriodID, year, week);

      // Show success message
      createPopup("Download Complete", `Paycor PRDA Local file for week ${week}, ${year} has been downloaded successfully.`);

    } catch (error) {
      console.error("Error downloading Paycor PRDA Local file:", error);
      createPopup("Download Failed", `Failed to download Paycor PRDA Local file for week ${week}, ${year}. Please try again.`);
      setError("Failed to download Paycor PRDA Local file");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageWrapper title={translator.translate("paycorPrdaLocal")} backgroundColor={Colors.White} weekSelector={true}>
      <div className="downloadable-data">
        <button className="download-btn" onClick={handleDownloadClick}>
        {translator.translate("DownloadPaycorPrdaLocalForWeek")} {week} / {year}
        </button>
      </div>
    </PageWrapper>
  );
};

export default PaycorPrdaLocal;
